"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.channels.title': 'Integracje kanałów',
    'socialMediaPlan.channels.desc': 'Podłącz i zarządzaj kontami social media.',
};
